var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isOpen
    ? _c("ModalFullScreen", {
        attrs: { withBgClickEvent: true },
        on: { close: _vm.handleClose },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "flex items-center pb-2" }, [
                    _c("h2", { staticClass: "text-md font-bold" }, [
                      _vm._v(_vm._s(_vm.conversationName)),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "cursor-pointer flex items-center justify-center absolute top-3 right-3",
                        on: {
                          click: _vm.handleClose,
                          mouseover: function ($event) {
                            _vm.isHovered = true
                          },
                          mouseout: function ($event) {
                            _vm.isHovered = false
                          },
                        },
                      },
                      [
                        !_vm.isHovered
                          ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                        _vm.isHovered
                          ? _c("CrossIconHover", { staticClass: "w-4 h-4" })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "my-3 pb-3 flex flex-row flex-wrap gap-2" },
                    _vm._l(_vm.participants.all, function (participant, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "flex items-center sm:mb-1.5 borderAvatar",
                        },
                        [
                          _c("CircleWithInitials", {
                            staticClass: "mr-2 flex",
                            class: _vm.participantStatusStyle(participant),
                            attrs: {
                              title: participant.initial,
                              avatar: participant.avatar,
                              customText: "customText",
                              primary: "",
                              large: "customModal",
                            },
                          }),
                          _c(
                            "p",
                            {
                              staticClass: "customText",
                              class: _vm.participantStatusStyle(participant),
                            },
                            [_vm._v(_vm._s(participant.initial))]
                          ),
                          participant.deleted
                            ? _c("p", { staticClass: "opacity-50 ml-3" }, [
                                _vm._v(" (left conversation) "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "flex justify-end" },
                    [
                      _c("UiButton", {
                        attrs: {
                          variant: "outline-black",
                          buttonText: "Go back",
                          size: "lg",
                        },
                        on: { click: _vm.handleClose },
                      }),
                      _c("UiButton", {
                        staticClass: "ml-3",
                        attrs: {
                          variant: "black",
                          buttonText: "Leave Conversation",
                          size: "lg",
                        },
                        on: { click: _vm.handleLeaveConversation },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          664181988
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }